import React from 'react'
import styled, { withTheme } from 'styled-components'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import ActionButton from '../../../components/button/ActionButton'
import { copyDeckListToClipBoard, getTcgPlayerMassEntryLink } from '../../../helper/deck'
import Icon from '../../../components/general/Icon'
import PriceSourceLink, { StyledPriceSourceLink } from '../../../components/price/PriceSourceLink'
import { CARD_MARKET, TCG_PLAYER } from '../../../data/priceSources'
import translate from '../../../helper/translate'
import { showToast } from '../../../state/actions/app'

const DeckBuyLinks = ({ cardNameLanguage, deckCards, showToast, t, theme }) => (
	<BuyActions>
		<ActionButton
			color={theme.secondary}
			onClick={() => {
				copyDeckListToClipBoard(deckCards, cardNameLanguage, t)

				showToast('success', t('general.missingCardsCopied'))
			}}
			icon="clipboard-copy"
		>
			{t('general.copyMissingCards')} ({deckCards.length})
		</ActionButton>

		<Icon name="arrow-right" />

		<BuyActionsRight>
			<PriceSourceLink
				externalLink="/YuGiOh/Wants"
				priceSource={CARD_MARKET}
			/>
			<PriceSourceLink
				externalLink={getTcgPlayerMassEntryLink(deckCards)}
				priceSource={TCG_PLAYER}
			/>
		</BuyActionsRight>
	</BuyActions>
)

DeckBuyLinks.propTypes = {
	cardNameLanguage: PropTypes.string,
	deckCards: PropTypes.array.isRequired,
	showToast: PropTypes.func.isRequired,
	t: PropTypes.func.isRequired,
	theme: PropTypes.object.isRequired
}

DeckBuyLinks.defaultProps = {
	cardNameLanguage: null
}

const BuyActions = styled.div`
	background: ${props => props.theme.backgroundLight};
	border-radius: 6px;
	padding: 1rem;

	align-items: center;
	display: flex;
	gap: 1rem;
	justify-content: space-between;
	margin-bottom: 1rem;

	> svg {
		color: ${props => props.theme.textLight};
	}
`

const BuyActionsRight = styled.div`
	align-items: center;
	display: flex;
	gap: 0.5rem;

	${StyledPriceSourceLink} {
		background: ${props => props.theme.background};
		width: 50px;

		display: flex;
		justify-content: center;
	}
`

const enhance = compose(
	connect(state => ({
		cardNameLanguage: state.persist.user.settings['app.cardNameLanguage'],
	}), dispatch => bindActionCreators({
		showToast
	}, dispatch)),
	translate('general'),
	withTheme
)

export default enhance(DeckBuyLinks)
